import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const DELETE_FILES_RESET = 'DELETE_FILES_RESET';
export const DELETE_FILES_LOADING = 'DELETE_FILES_LOADING';
export const DELETE_FILES_SUCCESS = 'DELETE_FILES_SUCCESS';
export const DELETE_FILES_REJECT = 'DELETE_FILES_REJECT';

//* ACTIONS ------------------------------------------------
export const deleteFilesReset = () => ({ type: DELETE_FILES_RESET });
export const deleteFilesLoading = () => ({ type: DELETE_FILES_LOADING });
export const deleteFilesSuccess = (payload) => ({ type: DELETE_FILES_SUCCESS, payload });
export const deleteFilesReject = (payload) => ({ type: DELETE_FILES_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const deleteFilesRequest = async (data = {}, getState) => {
    const options = await withToken({
        method: Methods.DELETE,
        data,
    }, getState);
    return request(`/Route/web/DeleteRouteUploadFile/${data}`, options);
};